import React from 'react';
import { Phone, Calendar } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-announcement">
            <span>🏠 Professional Home Medical Care</span>
          </div>
          
          <h1 className="heading-hero">
            Quality Healthcare <br />
            Delivered to Your Home
          </h1>
          
          <p className="hero-subtitle body-large">
            Experience affordable medical care in the comfort of your home.
            <br />
            <span style={{ whiteSpace: 'nowrap' }}>Dr Ismail M. Meer</span>, a general practitioner, brings a wide range of medical services directly to you across Durban and surrounding areas.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <a href="#booking" className="btn-primary">
              <Calendar size={18} className="mr-2" />
              Book Home Visit
            </a>
            <a href="tel:0674933211" className="btn-secondary">
              <Phone size={18} className="mr-2" />
              Call Now
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-4 text-center">
            <div className="stat-badge">
              <div className="heading-3">MBBS</div>
              <div className="caption">Qualified Physician</div>
            </div>
            <div className="stat-badge">
              <div className="heading-3">HPCSA</div>
              <div className="caption">Registered Practitioner</div>
            </div>
            <div className="stat-badge">
              <div className="heading-3">7 Days</div>
              <div className="caption">Available Weekly</div>
            </div>
            <div className="stat-badge">
              <div className="heading-3">15+ Areas</div>
              <div className="caption">Service Coverage</div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
